import { HttpErrorResponse } from "@angular/common/http";
import type { ErrorEvent } from "@sentry/angular";

// HTTP errors that are normal control flow (handled at the call site) and must not spend Sentry quota.
export const EXPECTED_HTTP_ERRORS: { status: number; url: RegExp }[] = [{ status: 404, url: /\/programs\/[^/]+\/config$/ }];

export function isExpectedHttpError(error: HttpErrorResponse): boolean {
  return EXPECTED_HTTP_ERRORS.some(({ status, url }) => error.status === status && url.test(error.url ?? ""));
}

// HttpErrorResponse is not an Error, so Sentry stores it as a raw object ("Object captured as exception
// with keys: …"): no message, and every endpoint collapses into one group. Rewrite it into a readable,
// per-endpoint event, collapsing the program slug so one endpoint groups regardless of program.
export function normalizeHttpErrorEvent(event: ErrorEvent, error: HttpErrorResponse): ErrorEvent {
  const url = error.url ?? "unknown";
  let path = url;
  try {
    path = new URL(url, window.location.origin).pathname.replace(/\/programs\/[^/]+/g, "/programs/:programId");
  } catch {
    // Non-absolute or malformed URL: keep the raw value for fingerprinting.
  }
  event.exception = undefined;
  event.message = `HTTP ${error.status} ${path}`;
  event.fingerprint = ["http", String(error.status), path];
  event.contexts = { ...event.contexts, response: { status_code: error.status, url, body: error.error } };
  return event;
}
